import { OktaAuth } from "@okta/okta-auth-js";

const NONPROD_ISSUER =
  "https://nike-qa.oktapreview.com/oauth2/ausa0mcornpZLi0C40h7";
const PROD_ISSUER = "https://nike.okta.com/oauth2/aus27z7p76as9Dz0H1t7";

const isProd = import.meta.env.VITE_ENVIRONMENT === "production";

/** True when built with a real Okta issuer (production UI builds). */
export const OKTA_ENABLED = !!import.meta.env.VITE_OKTA_ISSUER;

export const oktaAuth = new OktaAuth({
  issuer:
    import.meta.env.VITE_OKTA_ISSUER ||
    (isProd ? PROD_ISSUER : NONPROD_ISSUER),
  clientId:
    import.meta.env.VITE_OKTA_CLIENT_ID || "nike.niketech.customs",
  redirectUri: `${window.location.origin}/login/callback`,
  scopes: ["openid", "profile", "email"],
  pkce: true,
  responseType: "code",
});
